import React from 'react';
import Slider from "react-slick";
import Card from "./Card";
import './Projects.css';

export default function Projects() {
    const projects = [
        {
            image: "/projects/drawTogether.png",
            title: "Trace Together",
            description: "A real-time interactive whiteboard designed for seamless collaboration. Users can draw, erase, and annotate on a shared digital canvas",
            link: "https://github.com/Dramocrystal/TraceTogether",
            technologies: ['React', 'NodeJs', 'WebSockets'],
        },
        {
            image: "/projects/sportscenter.png",
            title: "Sports Center WebApp",
            description: "A web app where users can register for sports classes and manage their profiles, including a dashboard to view the sessions they are attending or supervising. The owner manages classes, instructors, and sports center details",
            link: "https://github.com/Dramocrystal/SportsCenterApp",
            technologies: ['Java', 'Springboot', 'PostgreSQL', 'VueJs'],
        },
        {
            image: "/projects/ballongame.png",
            title: "Balloon Shooting Game",
            description: "A game where the player shoots balloon. Implemented collisions detection/resolution and physics from scratch",
            link: "https://github.com/Dramocrystal/BalloonGame",
            technologies: ['Unity', 'C#'],
        },
        {
            image: "/projects/concurrent.png",
            title: "Multithreading Coursework",
            description: "A collection of Java and C programs that explore parallelism and thread synchronization using real-world concurrency patterns. Includes simulations like multithreaded bracket matching and a concurrent Snakes & Ladders game.",
            link: "https://github.com/Dramocrystal/concurrent-programming",
            technologies: ['Java', 'C', 'Multithreading'],
        },
        {
            image: "/projects/shell.png",
            title: "Simulated Shell in C",
            description: "Built a simulated OS shell with process scheduling (FCFS, SJF, Round Robin, Aging) and demand paging with LRU replacement for memory management.",
            link: "https://github.com/Dramocrystal/SimulatedShell",
            technologies: ['C', 'Shell', 'Multithreading', 'Scheduling'],
        },
        {
            image: "/projects/portfolio.png",
            title: "My Portfolio Website :D",
            description: "A personal portfolio showcasing my projects and skills as a computer engineering student, highlighting my journey and expertise in full-stack development.",
            link: "https://github.com/Dramocrystal",
            technologies: ['React', 'ThreeJs'],
        },
        {
            image: "/projects/catchthefruits.png",
            title: "Catch the fruits",
            description: "A simple python game where the player has to catch fruits and dodge bombs falling from the sky",
            link: "https://github.com/Dramocrystal/CatchTheFruits",
            technologies: ['Python', 'PyGame'],
        },
        {
            image: "/projects/assetplus.png",
            title: "AssetPlus",
            description: "A hotel management app for tracking assets and handling complaints.",
            link: "https://github.com/Dramocrystal",
            technologies: ['Java', 'Gerkhin', 'JSON'],
        },
        {
            image: "/projects/blockgame.png",
            title: "BlockGame",
            description: "A turn-based game where players complete random color objectives, like forming the largest square or filling the perimeter with matching squares.",
            link: "https://github.com/Dramocrystal/Block-Game",
            technologies: ['Java'],
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0'
                }
            }
        ]
    };

    return (
        <>
            <div className="header-container">
                <h1 className="title">MY PROJECTS</h1>
            </div>
            <div className="slider-container">
                <Slider {...settings}>
                    {projects.map((project, index) => (
                        <div key={index}>
                            <Card
                                image={project.image}
                                title={project.title}
                                description={project.description}
                                link={project.link}
                                technologies={project.technologies}
                            />
                        </div>
                    ))}
                </Slider>
            </div>
        </>
    );
}
